//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeInOuts', {
//        templateUrl: 'views/components/views/timeInOuts/timeInOuts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'timeInOutsService', function ($stateParams, timeInOutsService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                itemsListTimeInOuts: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTimeInOuts() {
//                vm.model.itemsListTimeInOuts = await timeInOutsService.listTimeInOuts({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadTimeInOuts();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
